<div class="editor">
    <div class="editor__header">
        <h1 class="header__title">עריכת הודעה</h1>

        <button class="header__close" (click)="closeDialog()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>

    <div class="editor__body">
        <div class="input-wrapper input-wrapper_type_textarea editor__textarea-wrapper">
            <h2 class="editor__title">ערוך הודעת טקסט</h2>

            <textarea
                #textareaElement
                class="input custom-scrollbar"
                [(ngModel)]="textarea"
                (click)="textareaClick($event)"
                (keydown)="textareaClick($event)"
                (keyup)="textareaKeyUp()"
                (paste)="textareaPaste($event)"
            ></textarea>

            <span class="editor__warning">
                שימו לב: אין להוסיף מלל שיווקי להודעה זו
                <i class="fa-regular fa-circle-exclamation"></i>
            </span>
        </div>

        <div class="editor__controls">
            <h2 class="editor__title">תגיות נוספות</h2>

            <div class="layouts custom-scrollbar">
                <button
                    *ngFor="let layout of layouts"
                    class="button button_size_small button_with-icon layout__button"
                    [ngClass]="{
                        'button_theme_main-line': !layout.mandatory && !layout.isUsed,
                        'button_theme_red-line': layout.mandatory && !layout.isUsed,
                        'button_theme_gray-line': layout.isUsed
                    }"
                    (click)="layoutClick(layout)"
                >
                    {{ layout.hebrew_name }}
                    <i class="fa-regular fa-plus"></i>
                </button>
            </div>

            <span emojiPickerIf="true" emojiPickerDirection="bottom" (emojiPickerSelect)="emojiClick($event.char)"></span>
        </div>
    </div>

    <div class="editor__footer">
        <p class="footer__information">
            בהפעלת שליחת ההודעות האוטומטית המשתמש במערכת מתחייב להקפיד על קיום הוראות הדין ובפרט על הוראות סעיף 30א' לחוק התקשורת, התשס"ח–2008 (חוק
            הספאם). לתקנות המלאות לחצו <a href="https://www.optimus.co.il/terms_of_use/" target="_blank">כאן</a>, לשאלות פנו אלינו 03-6529954
        </p>

        <div *ngIf="!isSaveable" class="footer__error">לא תוכלו לשמור את התבנית ללא תגיות חובה שמסומנות באדום למעלה</div>

        <button class="button button_size_small button_with-icon button_theme_main footer__button" [disabled]="!isSaveable" (click)="saveText()">
            שמירה וסגירה
            <i class="fa-regular fa-floppy-disk"></i>
        </button>
    </div>
</div>
